module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/store_hokkaido@3x-b8cb864dc08d05fdfa21e854b3b876c3.webp";